import { render, staticRenderFns } from "./Install.vue?vue&type=template&id=0bdca4b0&scoped=true"
import script from "./Install.vue?vue&type=script&lang=js"
export * from "./Install.vue?vue&type=script&lang=js"
import style0 from "./Install.vue?vue&type=style&index=0&id=0bdca4b0&prod&lang=scss&scoped=true"
import style1 from "./Install.vue?vue&type=style&index=1&id=0bdca4b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdca4b0",
  null
  
)

export default component.exports